import { Box, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import IconButtonTitle from '../../../common/component/IconButtonTitle';
import MediCard from '../../../common/component/MediCard';
import TableCustom, { Columns } from '../../../common/component/TableCustom';
import { some } from '../../../common/constants';
import { NumericFormatText } from 'modules/common/utils';
import { Service } from 'modules/schema';
import { isEmpty } from 'lodash';

interface Props {
  data?: some;
  setFormData: (item: some) => void;
  setFormDataGroup: (item: some) => void;
  onDelete: (item: some) => void;
  onDeleteGroup: (item: some) => void;
  onDeleteServices: (services: Service[]) => void;
  loading?: boolean;
  enableDeleteGroup?: boolean;
}

const ServiceTable: React.FunctionComponent<Props> = (props) => {
  const { data, setFormData, setFormDataGroup, onDelete, onDeleteGroup, onDeleteServices, enableDeleteGroup, loading } =
    props;
  console.log('props', props);

  const [selection, setSelection] = React.useState<Service[]>([]);

  const columns = React.useMemo(() => {
    return [
      {
        title: 'serviceCode',
        dataIndex: 'code',
      },
      {
        title: 'serviceName',
        dataIndex: 'name',
        render: (record) => <Typography color={record?.name.length > 255 ? 'red' : ''}>{record?.name}</Typography>,
      },
      {
        title: 'departmentCode',
        dataIndex: 'specializedDepartment.code',
      },
      {
        title: 'service.room',
        dataIndex: 'physicsRoom.name',
      },
      {
        title: 'price',
        dataIndex: 'price',
        render: (record) => record.price && NumericFormatText(record.price),
      },
      {
        title: 'action',
        width: 120,
        render: (record) => {
          const { specializedDepartment = {}, physicsRoom = {} } = record;
          return (
            <>
              <IconButtonTitle
                title="update"
                size="small"
                onClick={() => {
                  setFormData({
                    ...record,
                    systemCategoryId: data?.id,
                    department: specializedDepartment.id,
                    room: { value: physicsRoom.id, label: physicsRoom.name },
                  });
                }}
                style={{ margin: '0px 8px' }}
              >
                <EditIcon color={record.validation === false ? 'error' : undefined} />
              </IconButtonTitle>
              <IconButtonTitle
                title="delete"
                size="small"
                onClick={() => {
                  onDelete({ ...record });
                }}
              >
                <DeleteIcon />
              </IconButtonTitle>
            </>
          );
        },
      },
    ] as Columns[];
  }, [setFormData, data?.id, onDelete]);

  if (!data) {
    return null;
  }

  const funcDeleteServices = () => {
    onDeleteServices(selection);
    setSelection([]);
  };

  return (
    <MediCard
      style={{ margin: '8px 0px', color: 'white' }}
      title={
        <Box display="flex" alignItems="center">
          <Box flex={1}>
            <Typography variant="subtitle1" color="inherit">
              {data.name}
            </Typography>
          </Box>
          <Box display="flex">
            <IconButtonTitle
              title="create"
              size="small"
              color="inherit"
              onClick={() => setFormData({ systemCategoryId: data.id })}
            >
              <NoteAddIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="update"
              size="small"
              color="inherit"
              onClick={() => setFormDataGroup(data)}
              style={{ margin: '0px 8px' }}
            >
              <EditIcon />
            </IconButtonTitle>
            <IconButtonTitle
              title="delete"
              size="small"
              color="inherit"
              disabled={!!data.items?.length && !enableDeleteGroup && isEmpty(selection)}
              onClick={() => {
                !isEmpty(selection) ? funcDeleteServices() : onDeleteGroup(data);
              }}
            >
              <DeleteIcon />
            </IconButtonTitle>
          </Box>
        </Box>
      }
    >
      <Box padding={1}>
        <TableCustom
          dataSource={data?.items}
          loading={loading}
          columns={columns}
          rowSelection={{
            selectedRowKeys: selection,
            onChange: ({ selectedRows }) => setSelection(selectedRows),
          }}
          caption={
            <Button
              size="large"
              fullWidth
              variant="text"
              startIcon={<NoteAddIcon />}
              color="primary"
              onClick={() => setFormData({ systemCategoryId: data.id })}
            >
              <Typography variant="subtitle2">
                <FormattedMessage id="service.addNewInList" />
              </Typography>
            </Button>
          }
        />
      </Box>
    </MediCard>
  );
};

export default ServiceTable;
